import React, { useContext, useEffect } from "react";
import PlayerTile from "./PlayerTile.jsx";
import "./Players.scss";
import {
  getPlayersWithActiveSuspensions,
} from "../../../Base/Utilities/Suspension.js";
import { FixtureDetailsContext } from "../../../../Config/FixtureDetails.jsx";
import { sendInternalEvent } from "../../../Base/Utilities/SendEvent.js";

const SuspendedPlayers = (props) => {
  const { currentState, eventStore, updateState } = props;
  const { fixtureProfile } = useContext(FixtureDetailsContext);

  useEffect(() => {
    if (!currentState?.mqtt?.internalEvents) {
      return;
    }

    const playersWithActiveSuspensions = getPlayersWithActiveSuspensions(
      currentState, eventStore, fixtureProfile
    );
    const uniqueTeamEvents = playersWithActiveSuspensions.map(team => {
      return team.filter((value, index, self) =>
        index === self.findIndex((event) => event.personId === value.personId),
      );
    });
    const maxSuspendedPlayers = uniqueTeamEvents.map((events) => events.length).filter(num => num >= 2).length;

    if (currentState.maxSuspendedPlayers === 0 && maxSuspendedPlayers === 1) {
      sendInternalEvent("betStop", currentState);
    }

    updateState("maxSuspendedPlayers", maxSuspendedPlayers);
  }, [currentState.entities]);

  return (
    <div className="suspended-players">
      {[0, 1].map((entityIndex) => {
        return <div className="suspended-players--team" key={entityIndex}>
          {currentState?.entities[entityIndex]?.persons.map((player) => {
            return (
              <PlayerTile
                player={player}
                entity={currentState.entities[entityIndex]}
                eventStore={eventStore}
                currentState={currentState}
                key={player.personId}
                {...props}
              ></PlayerTile>);
          })}
          {currentState?.entities[entityIndex]?.staff.map((player) => {

            // show a tile for a staff member if they are not in the players list
            if (currentState?.entities[entityIndex]?.persons.find(
              p => p.personId === player.personId)) {
              return null;
            }

            return (
              <PlayerTile
                player={player}
                entity={currentState.entities[entityIndex]}
                eventStore={eventStore}
                currentState={currentState}
                key={player.personId}
                {...props}
              ></PlayerTile>);
          })}
        </div>;
      })}
    </div>
  );
};

export default SuspendedPlayers;
